import React from "react";
import { API_URL } from "../../../constants/api";
import { apiBatchRequest, apiPost, apiRequest } from "../../../utils/api_service";
import "./contacts.less";
import { ShowToast, toastType } from "../../../utils/toast-service";
import commonLabels from "../../../constants/messageConstants";
import ConfirmDialog from "../../common/Dailogbox/ConfirmDailog";
import {
  Checkbox,
  FormControlLabel,
  Tooltip,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  Typography,
  Toolbar,
  AppBar,
  Dialog
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import EmailIcon from "@material-ui/icons/Email";
import AddUpdateTenantContact from "./addUpdateContact";
import {
  convertIntoDDFormat,
  getPhoneNumberWithMask
} from "../../../utils/generic";
import { sortBy } from "lodash/collection";
import uniqBy from "lodash/uniqBy";
import moment from "moment";
import {
  GetPropertyVisibility,
  IsSectionVisible,
  PaperComponent,
  getColorClass,
  removeDuplicates,
  sortArray
} from "../../../utils/helper";
import PaginationControlled from "../../common/pagination/pagination";
import { SECTIONS } from "../../../constants/appConstants";
import TableHeaderWithFilter from "../../common/table-header-filter";
import { filterTableRows } from "../../../utils/filtered";
import { getArrayIndex, getArrayObject } from "../../../utils/lodash";
import DownloadSSRSPopUp from "../../common/button-download-popup";
import { Tenant_Contact_List } from "../../../constants/ssrs_api";
import { downloadExcelReportByAPI } from "../../../utils/downloading";
import { IoMdCloseCircleOutline } from "react-icons/io";
import FilterOff from "../../../public/img/common/filterOff.svg";
import RefreshIcon from "@material-ui/icons/Refresh";
import { convertAPIDateInStdFormat, getDiffInDays } from "../../../utils/date";

class ContactsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenantId: props.selectedTenantId,
      selectedPropertyId: props.selectedPropertyId,
      tenantContactsList: [],
      isUpdateDialogOpen: false,
      isShowInActive: false,
      clickedContactId: "",
      masterData: "",
      pageNo: 0,
      rowsPerPagination: 25,
      colFilteredObj: [],
      sortByColKey: "",
      isShowColFilter: true,
      reload: false,
      selectedSource: [],
      selectedIds: {},
      refreshFilteredObj: false,
      clearData: false,
      keepFilterData: false,
      toolTipData: []
    };
  }

  

  componentDidMount() {
    //fetch list data
    this.state.tenantId && this.getTenantContactsList(this.state.tenantId);
    this.getMasterData();
  }

  /**
   * call on refresh icon button
   */
  resetPage = () => {
    this.state.tenantId && this.getTenantContactsList(this.state.tenantId);
  };

  /**
   * get master data list
   */
  getMasterData = () => {
    const props = this.props;
    apiBatchRequest([
      {
        url: API_URL.masterData.GetRequestMasterData,
        key: "masterData"
      },
      {
        url: API_URL.masterData.GetLabels,
        params: { sectionId: SECTIONS.ADD_UPDATE_CONTACT },
        key: "toolTipData"
      }
    ]).then(({ masterData, toolTipData }) => {
      this.setState({
         masterData: masterData?.data || [],
         toolTipData: toolTipData.data || [],
         isUpdateDialogOpen: props.isAddDialogOpen ? props.isAddDialogOpen : false
      });
    });
  };

  /**
   * Get tenant contacts list according to tenant id
   * @param {*} tenantId
   */
  getTenantContactsList = tenantId => {
    const params = {
      tenantId: tenantId,
      DateOffSet: moment().utcOffset()
    };
    apiRequest({
      url: API_URL.tenantContact.GetTenantContacts,
      params
    }).then(({ data: List }) => {
    const { colFilteredObj, reload } = this.state;
      this.setState({
        tenantContactsList: List,
        keepFilterData: true,
        reload: !reload,
        selectedSource: colFilteredObj,
        clearData: false,
        sortByColKey: ""
      });
    });
  };


  /**
   * call on resend invitation email
   * @param {*} res
   */
  handleSendEmail = res => {
    if (res) {
      this.sendInvitationEmail();
    } else {
      this.openSendEmailDialog(false, 0);
    }
  };

  /**
   * send invitation email api
   */
  sendInvitationEmail = () => {
    const {
      userName,
      emailId,
      clickedContactId,
      tenantContactsList
    } = this.state;
    this.openSendEmailDialog(false, 0);

    let postBody = {};
    const year = new Date().getFullYear();
    const day = new Date().getDate();
    const month = new Date().getMonth();

    if (emailId && emailId.length > 0) {
      postBody = {
        contactEmails: [
          {
            emailId: emailId,
            userName: userName,
            tenantUserId: clickedContactId
          }
        ]
      };
    } else {
      const contactEmails = [];
      tenantContactsList.map(user => {
        if (
          user.ExpireDate == null ||
          (user.ExpireDate &&
            new Date(
              new Date(user.ExpireDate).getFullYear(),
              new Date(user.ExpireDate).getMonth(),
              new Date(user.ExpireDate).getDate()
            ) >= new Date(year, month, day))
        ) {
          contactEmails.push({
            emailId: user.Email,
            userName: user.UserName,
            tenantUserId: user.TenantUserId
          });
        }
      });

      postBody = {
        contactEmails: contactEmails
      };
    }

    apiPost({
      url: API_URL.tenantContact.SendEmailNotification,
      postBody: postBody
    }).then(response => {
      if (!response.success) {
        ShowToast(
          "Server Error: Unable to send invitation email.",
          toastType.ERROR,
          5000,
          500
        );
      } else {
        ShowToast(
          "Invitation Email has been sent successfully.",
          toastType.SUCCESS,
          5000,
          200
        );
        this.getTenantContactsList(this.state.tenantId);
      }
    });
  };

  /**
   * open update dialog pop up
   * @param {*} isOpen
   * @param {*} TenantUserId
   */
  openUpdateDialog = (isOpen = true, TenantUserId = "") => {
    this.setState({
      isUpdateDialogOpen: isOpen,
      clickedContactId: TenantUserId
    });
  };

  /**
   * open send email dialog pop up
   * @param {*} isOpen
   * @param {*} emailId
   * @param {*} userName
   * @param {*} tenantUserId
   */
  openSendEmailDialog = (
    isOpen = true,
    emailId = "",
    userName = "",
    tenantUserId = 0
  ) => {
    this.setState({
      isOpenSendEmailDialog: isOpen,
      emailId: emailId,
      userName: userName,
      clickedContactId: tenantUserId
    });
  };

  /**
   * Refresh tenant list
   * @param {*} isTenantSaved
   */
  refreshTenants = (isTenantSaved = false) => {
    const { colFilteredObj, reload } = this.state;

    this.setState({
      keepFilterData: true,
      reload: !reload,
      selectedSource: colFilteredObj,
      clearData: false
    });
    if (isTenantSaved) {
      this.getTenantContactsList(this.state.tenantId);
    }
    this.openUpdateDialog(false);
  };

  /**
   * filter data according to applied filter
   * @param {*} listData
   * @returns
   */
  getFilterList = listData => {
    const { isShowInActive, colFilteredObj, sortByColKey } = this.state;

    const year = new Date().getFullYear();
    const day = new Date().getDate();
    const month = new Date().getMonth();

    if (!isShowInActive) {
      listData =
        listData?.filter(
          f =>
            f.ExpireDate == null ||
            (f.ExpireDate &&
              new Date(
                new Date(f.ExpireDate).getFullYear(),
                new Date(f.ExpireDate).getMonth(),
                new Date(f.ExpireDate).getDate()
              ) >= new Date(year, month, day))
        ) || [];
    }
    const fData = sortBy(
      filterTableRows(listData, colFilteredObj),
      x => x[sortByColKey]
    );

    return fData;
  };

  /**
   * call on pagination dropdown changes
   * @param {*} pageNo
   * @param {*} rowsPerPagination
   */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination });
  };

  /**
   * update column filter according to applied filters
   * @param {*} key
   * @param {*} value
   * @param {*} filterType
   */
  updateColumnFilter = (key, value = "", filterType) => {
    const { colFilteredObj, selectedIds} = this.state;
    const index = getArrayIndex(colFilteredObj, { keyName: key });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: key,
        value,
        filterType: filterType || "string"
      };
      key &&
        this.setState({
          colFilteredObj: colFilteredObj,
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        });
    } else {
      key &&
        this.setState({
          colFilteredObj: [
            ...colFilteredObj,
            { keyName: key, value, filterType: filterType || "string" }
          ],
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        });
    }
  };

  /**
   * download SSRS excel or pdf
   * @param {*} report
   * @param {*} type
   */
  downloadSSRSReport = (report, type = "excel") => {
    const { colFilteredObj, masterData, isShowInActive, tenantId } = this.state;
    const siteIds = "All";
    let requestTypeIds = "All";

    const contactType =
      colFilteredObj.filter(f => f.keyName == "ContactType")[0]?.value || "All";
    const requestTypes =
      colFilteredObj
        .filter(f => f.keyName == "RequestTypes")[0]
        ?.value.toString() || [];

    if (requestTypes && requestTypes.length > 0) {
      requestTypeIds = "";
      requestTypes.split(",").forEach(function(r) {
        if (r == "All") {
          requestTypeIds = "All";
          return;
        } else {
          requestTypeIds +=
            (masterData.requestTypeMaster || []).find(y => y.RequestType === r)
              ?.RequestTypeId + ",";
        }
      });
    }
    const dateFilter = colFilteredObj.filter(f => f.keyName == "LastloggedOn")[0]
      ?.value;
    let fromDate = "IsNull=True";
    let toDate = "IsNull=True";
    if (dateFilter && dateFilter.length > 0) {
      [fromDate, toDate] = dateFilter.split("-");
    }

    const dateFilterForInvitation = colFilteredObj.filter(
      f => f.keyName == "InvitationSentDate"
    )[0]?.value;
    let fromDateInvitation = "IsNull=True";
    let toDateInvitation = "IsNull=True";
    if (dateFilterForInvitation && dateFilterForInvitation.length > 0) {
      [fromDateInvitation, toDateInvitation] = dateFilterForInvitation.split(
        "-"
      );
    }

    // add expire date parameter
    const dateFilterForExpiration = colFilteredObj.filter(
      f => f.keyName == "ExpireDate"
    )[0]?.value;
    let fromDateExpiration = "IsNull=True";
    let toDateExpiration = "IsNull=True";
    if (dateFilterForExpiration && dateFilterForExpiration.length > 0) {
      [fromDateExpiration, toDateExpiration] = dateFilterForExpiration.split(
        "-"
      );
    }

    const param = `&TenantContactStatus=${
      isShowInActive ? "Inactive" : "Active"
    }&DataCenter=${siteIds}&ContactName=${getValueFrom(
      "UserName"
    )}&OfficePhone=${getValueFrom("OfficePhone")}&CellPhone=${getValueFrom(
      "CellPhone"
    )}&SearchEmail=${getValueFrom("Email")}&RequestPermissions=${
      requestTypeIds.length === 0 ? "All" : requestTypeIds
    }&TenantId=${tenantId}${(fromDateInvitation == "IsNull=True"
      ? "&InvitationSentFromDate:"
      : "&InvitationSentFromDate=") + fromDateInvitation}${(toDateInvitation ==
    "IsNull=True"
      ? "&InvitationSentToDate:"
      : "&InvitationSentToDate=") + toDateInvitation}${(fromDate ==
    "IsNull=True"
      ? "&LastLoggedOnFromDate:"
      : "&LastLoggedOnFromDate=") + fromDate}${(toDate == "IsNull=True"
      ? "&LastLoggedOnToDate:"
      : "&LastLoggedOnToDate=") +
      toDate}&Role=${contactType}&DateOffset=${moment().utcOffset()}
    ${(fromDateExpiration == "IsNull=True"
      ? "&ExpirationFromDate:"
      : "&ExpirationFromDate=") + fromDateExpiration}
    ${(toDateExpiration == "IsNull=True"
      ? "&ExpirationToDate:"
      : "&ExpirationToDate=") + toDateExpiration}`;
    switch (type) {
      case "pdf":
        downloadExcelReportByAPI(
          `${report.downloadLink}PDF${param}`,
          report.label,
          "application/pdf"
        );
        break;
      case "excel":
        downloadExcelReportByAPI(
          `${report.downloadLink}EXCELOPENXML${param}`,
          report.label
        );
        break;
    }

    function getValueFrom(keyVal, defaultVal = "All") {
      const obj = getArrayObject(colFilteredObj, { keyName: keyVal });
      return obj && obj.value ? obj.value : defaultVal;
    }
  };

  /**
   * set request permission value when click on count
   * @param {*} viewAll
   * @param {*} dataCenters
   * @param {*} title
   */
  handleViewAllRequestPermissions = (
    viewAll = false,
    dataCenters,
    title = ""
  ) => {
    this.setState({
      viewAllRequestPermission: viewAll,
      selectedRequestPermission: dataCenters,
      title
    });
  };

  /**
   * call on clear filter icon
   */
  clearFilter = () => {
    const { refreshFilteredObj } = this.state;

    this.setState({
      colFilteredObj: [],
      clearData: true,
      refreshFilteredObj: !refreshFilteredObj,
      sortByColKey: "",
      selectedIds: {}
    });
  };

  render() {
    const {
      tenantContactsList,
      isShowInActive,
      isUpdateDialogOpen,
      clickedContactId,
      tenantId,
      masterData,
      selectedPropertyId,
      isShowColFilter,
      toolTipData,
      refreshFilteredObj
    } = this.state;

    console.log(selectedPropertyId)
    const { isDisabledAdd, tenantEffectiveToDate } = this.props;
    const year = new Date().getFullYear();
    const day = new Date().getDate();
    const month = new Date().getMonth();

    const addContactVisible = IsSectionVisible(
      SECTIONS.TENANT,
      SECTIONS.ADD_UPDATE_CONTACT
    );

    const disabledProperty = GetPropertyVisibility(SECTIONS.ADD_UPDATE_TENANT);
    
    const isDisabledProperty = disabledProperty.find(dc => dc === selectedPropertyId) !== undefined;
    
    const tenantContactsListing = IsSectionVisible(
      SECTIONS.TENANT,
      SECTIONS.CONTACT_LIST
    );

    const filterList = this.getFilterList(tenantContactsList);

    const optionsListRequestType = uniqBy(
      convertIntoDDFormat(
        masterData.requestTypeMaster || [],
        "RequestType",
        "RequestType"
      ),
      x => x.id
    );

    const optionsListProperty = uniqBy(
      convertIntoDDFormat(masterData.propertyMaster || [], "Name", "Name"),
      x => x.id
    );

    return (
      <div className={"col-xs-12 tenantTable"}>
        <div className={"row"}>
          <div className={"col-xs-10 btnGrp"} style={{ display: "flex" }}>
            {
              <Button
                variant={"contained"}
                size={"small"}
                onClick={this.props.backToTenant}
              >
                {"Back To Tenant\r"}
              </Button>
            }
            {addContactVisible && (
              <Button
                variant={"contained"}
                size={"small"}
                onClick={this.openUpdateDialog}
                disabled={isDisabledAdd || isDisabledProperty}
              >
                {"Add Contact\r"}
              </Button>
            )}
            {
              <Button
                variant={"contained"}
                size={"small"}
                onClick={this.openSendEmailDialog}
              >
                {"Send Invitation Email to all\r"}
              </Button>
            }
            <FormControlLabel
              className={"checkbox-filter"}
              control={
                <Checkbox
                  id={"IsAccessible1"}
                  color={"primary"}
                  defaultValue={isShowInActive}
                  checked={isShowInActive}
                  onChange={event =>
                    this.setState({ isShowInActive: event.target.checked })}
                />
              }
              label={"Include Inactive"}
            />
            <FormControlLabel
              className={"show-filter"}
              control={
                <Checkbox
                  id={"filterCompletedOrCancelled"}
                  color={"primary"}
                  defaultValue={isShowColFilter}
                  checked={isShowColFilter}
                  onChange={event =>
                    this.setState({
                      isShowColFilter: event.target.checked,
                      colFilteredObj: [],
                      sortByColKey: "",
                      clearData: true,
                      refreshFilteredObj: !refreshFilteredObj,
                      selectedIds: {}
                    })}
                />
              }
              label={"Show Filters"}
            />
            <div style={{ marginTop: "10px" }}>
              <DownloadSSRSPopUp
                buttonLabel={"Print"}
                dataTip={
                  toolTipData?.find(
                    b => b.UiColumnName == "Download"
                  )?.Tooltip
                }
                reportList={[
                  {
                    label: "Tenant Contact List",
                    id: 1,
                    pdfDownload: true,
                    excelDownload: true,
                    downloadLink: Tenant_Contact_List
                  }
                ]}
                downloadBtnLabel={"Download"}
                downloadReport={this.downloadSSRSReport}
              />
            </div>
            <Tooltip title={
              toolTipData?.find(
                b => b.UiColumnName == "Clear Filter"
              )?.Tooltip
            } placement={"bottom"}
            >
              <img
                className={"iconsContact"}
                src={FilterOff}
                alt={"logo"}
                onClick={() => {
                  this.clearFilter();
                }}
              />
            </Tooltip>
          </div>
          <div className={"col-xs-2 end-xs"}>
            <Tooltip title={
               toolTipData?.find(
                b => b.UiColumnName == "Refresh"
               )?.Tooltip
            } placement={"bottom"}
            >
              <IconButton size={"small"} onClick={() => this.resetPage()}>
                <RefreshIcon
                  style={{
                    fill: "#365E7E",
                    marginTop: "7px",
                    width: "28px",
                    height: "30px"
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        <div className={"row "}>
          <div className={"col-xs-12"}>
            {isUpdateDialogOpen ? (
              <AddUpdateTenantContact
                isOpen={isUpdateDialogOpen}
                onClose={this.openUpdateDialog}
                onSave={this.refreshTenants}
                tenantContactId={clickedContactId}
                tenantId={tenantId}
                propertyId={selectedPropertyId}
                masterData={masterData}
                tenantContactsList={tenantContactsList}
                tenantEffectiveToDate={tenantEffectiveToDate}
                toolTipData={toolTipData}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <div className={"row "}>
          <div className={"contact-list-table-div"}>
            {tenantContactsListing ? (
              <table
                className={"contact-list-table"}
                style={{ fontWeight: "200 !important" }}
              >
                <thead>
                  <tr
                    className={"blue-cust-title"}
                    style={{ borderTop: "3px solid #FFFFFF" }}
                  >
                    <th
                      colSpan={12}
                      style={{
                        fontSize: "15px",
                        textAlign: "center",
                        lineHeight: "25px"
                      }}
                    >
                      {"Tenant Contacts\r"}
                    </th>
                  </tr>
                  <TableHeaderWithFilter
                    clearData={this.state.clearData}
                    refreshFilteredObj={this.state.refreshFilteredObj}
                    selectedId={this.state.selectedIds}
                    reload={this.state.reload}
                    keepFilterData={this.state.keepFilterData}
                    selectedSource={this.state.selectedSource}
                    columnData={[
                      {
                        headerClass: "w-10",
                        colName: "Data Center",
                        keyName: "PropertyName",
                        optionsList: optionsListProperty,
                        filterType: "multiSelect",
                        isHideFilter: true
                      },
                      {
                        headerClass: "w-15",
                        colName: "Contact Name",
                        keyName: "UserName"
                      },
                      {
                        headerClass: "w-10",
                        colName: "Work Phone",
                        keyName: "OfficePhone"
                      },
                      {
                        headerClass: "w-10",
                        colName: "Cell Phone",
                        keyName: "CellPhone"
                      },
                      {
                        headerClass: "w-15",
                        colName: "Email",
                        keyName: "Email"
                      },
                      {
                        headerClass: "w-15",
                        colName: "Effective To",
                        keyName: "ExpireDate",
                        filterType: "dateRange",
                        toolTip:  toolTipData?.find(
                          b => b.UiColumnName == "Expire Date"
                         )?.Tooltip || ""
                      },
                      {
                        headerClass: "w-5",
                        colName: "Request Permissions",
                        keyName: "RequestTypes",
                        optionsList: optionsListRequestType,
                        filterType: "multiSelect"
                      },
                      {
                        headerClass: "w-5",
                        colName: "Role",
                        keyName: "ContactType"
                      },
                      {
                        headerClass: "w-15",
                        colName: "Invitation Sent Date",
                        keyName: "InvitationSentDate",
                        filterType: "dateRange"
                      },
                      {
                        headerClass: "w-15",
                        colName: "Last Logged In",
                        keyName: "LastloggedOn",
                        filterType: "dateRange"
                      },
                      {
                        headerClass: "w-5",
                        colName: "Action",
                        isHideFilter: true,
                        textAlign: "center"
                      },
                      {
                        headerClass: "w-10",
                        colName: "Send Email",
                        isHideFilter: true,
                        textAlign: "center"
                      }
                    ]}
                    isShowFilter={isShowColFilter}
                    onChangeFilter={this.updateColumnFilter}
                  />
                </thead>
                <tbody>
                  {filterList && filterList.length > 0 ? (
                    (
                      (this.state.rowsPerPagination > 0
                        ? filterList.slice(
                            this.state.pageNo * this.state.rowsPerPagination,
                            this.state.pageNo * this.state.rowsPerPagination +
                              this.state.rowsPerPagination
                          )
                        : filterList) || []
                    ).map((item, index) => (
                      <tr key={"contacts" + index}>
                        <td>{item.PropertyName}</td>
                        <td>{item.UserName}</td>
                        <td>
                          {item.OfficePhone == null || item.OfficePhone == ""
                            ? "-"
                            : getPhoneNumberWithMask(item.OfficePhone)}
                        </td>
                        <td>
                          {item.CellPhone == null || item.CellPhone == ""
                            ? "-"
                            : getPhoneNumberWithMask(item.CellPhone)}
                        </td>
                        <td>{item.Email}</td>
                        <td>
                          <span
                            className={`colorText ${getColorClass(
                              getDiffInDays(
                                new Date(),
                                item.ExpireDate
                                  ? new Date(item.ExpireDate.split("T")[0])
                                  : ""
                              )
                            )}`}
                          >
                            {item.ExpireDate
                              ? convertAPIDateInStdFormat(
                                  item.ExpireDate.split("T")[0]
                                )
                              : "-"}
                          </span>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {item.RequestTypes == null ? (
                            "-"
                          ) : (
                            <>
                              <span
                                className={"underline"}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "0.7rem"
                                }}
                                onClick={() =>
                                  this.handleViewAllRequestPermissions(
                                    true,
                                    item.RequestTypes,
                                    "Request Permissions"
                                  )}
                              >
                                {
                                  removeDuplicates(item.RequestTypes.split(","))
                                    .length
                                }
                              </span>
                            </>
                          )}
                        </td>
                        <td>{item.ContactType}</td>
                        <td>
                          {(item.InvitationSentDate != null ||
                            item.InvitationSentDate != undefined) &&
                            moment(item.InvitationSentDate).format(
                              "MM/DD/YYYY hh:mm A"
                            )}
                        </td>
                        <td>
                          {(item.LastloggedOn != null ||
                            item.LastloggedOn != undefined) &&
                            moment(item.LastloggedOn).format(
                              "MM/DD/YYYY hh:mm A"
                            )}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Tooltip
                            title={
                              toolTipData?.find(
                                b => b.UiColumnName == "Edit"
                               )?.Tooltip
                            }
                            onClick={() => {
                              this.setState({
                                clickedContactId: item.TenantUserId
                              });
                              this.openUpdateDialog(true, item.TenantUserId);
                            }}
                          >
                            <IconButton
                              size={"small"}
                              disabled={!addContactVisible}
                            >
                              <EditIcon
                                size={"small"}
                                disabled={!addContactVisible}
                              />
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Tooltip
                            title={
                              item.ExpireDate &&
                              new Date(
                                new Date(item.ExpireDate).getFullYear(),
                                new Date(item.ExpireDate).getMonth(),
                                new Date(item.ExpireDate).getDate()
                              ) < new Date(year, month, day)
                                ?  <>
                                      { 
                                        toolTipData?.find(
                                        b => b.UiColumnName == "Inactive Tenant"
                                        )?.Tooltip
                                      }
                                   </>
                                : item.InvitationSentDate
                                ? 
                                  <>
                                    { 
                                      toolTipData?.find(
                                      b => b.UiColumnName == "Resend Invitation Email"
                                      )?.Tooltip
                                    }
                                  </>
                                : <>
                                    { 
                                      toolTipData?.find(
                                      b => b.UiColumnName == "Invitation Email"
                                      )?.Tooltip
                                    }
                                  </>
                            }
                            onClick={() => {
                              (item.ExpireDate == null ||
                                (item.ExpireDate &&
                                  new Date(
                                    new Date(item.ExpireDate).getFullYear(),
                                    new Date(item.ExpireDate).getMonth(),
                                    new Date(item.ExpireDate).getDate()
                                  ) >= new Date(year, month, day))) &&
                                this.openSendEmailDialog(
                                  true,
                                  item.Email,
                                  item.UserName,
                                  item.TenantUserId
                                );
                            }}
                          >
                            <span>
                              <IconButton
                                disabled={
                                  item.ExpireDate &&
                                  new Date(
                                    new Date(item.ExpireDate).getFullYear(),
                                    new Date(item.ExpireDate).getMonth(),
                                    new Date(item.ExpireDate).getDate()
                                  ) < new Date(year, month, day)
                                }
                                size={"small"}
                              >
                                {item.InvitationSentDate ? (
                                  <EmailIcon
                                    size={"small"}
                                    className={
                                      item.ExpireDate &&
                                      new Date(
                                        new Date(item.ExpireDate).getFullYear(),
                                        new Date(item.ExpireDate).getMonth(),
                                        new Date(item.ExpireDate).getDate()
                                      ) < new Date(year, month, day) &&
                                      "btn-disabled"
                                    }
                                  />
                                ) : (
                                  <EmailIcon
                                    size={"small"}
                                    className={
                                      item.ExpireDate &&
                                      new Date(
                                        new Date(item.ExpireDate).getFullYear(),
                                        new Date(item.ExpireDate).getMonth(),
                                        new Date(item.ExpireDate).getDate()
                                      ) < new Date(year, month, day) &&
                                      "btn-disabled"
                                    }
                                  />
                                )}
                              </IconButton>
                            </span>
                          </Tooltip>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td style={{ textAlign: "center" }} colSpan={5}>
                        {"No data available\r"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              <></>
            )}
          </div>
          {filterList && filterList.length > 0 && (
            <div className={"paginationContainer"}>
              <PaginationControlled
                tableLength={filterList.length}
                updateRowCount={this.updateRowCount}
                pageNo={this.state.pageNo}
                rowsPerPagination={this.state.rowsPerPagination}
              />
            </div>
          )}
          <ConfirmDialog
            IsOpen={this.state.isOpenSendEmailDialog}
            Message={commonLabels.sendEmailConfirmation.message}
            OnHandelClick={this.handleSendEmail}
            onClo
          />
        </div>
        <Dialog
          open={this.state.viewAllRequestPermission || false}
          onClose={() => this.handleViewAllRequestPermissions(false, "")}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {this.state.title}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"start"}
                color={"inherit"}
                onClick={() => this.handleViewAllRequestPermissions(false, "")}
                aria-label={"close"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {this.state.selectedRequestPermission &&
              sortArray(
                removeDuplicates(
                  this.state.selectedRequestPermission.split(",")
                )
              )?.map((obj, index) => (
                <Chip
                  className={"chip"}
                  key={"chip" + index + "c"}
                  label={obj}
                  style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                />
              ))}
          </DialogContent>
          <DialogActions>
            <Button
              color={"primary"}
              onClick={() => this.handleViewAllRequestPermissions(false, "")}
            >
              {"Close\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default ContactsTable;
